module.exports = __webpack_public_path__ + "img/warning.468ea3a2.png";